import { Button, Stack, Typography } from "@mui/material";
import React from "react";
import { IProperty } from "@/types/properties";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useTranslation } from "react-i18next";

type Props = {
  property?: IProperty;
  onClose: () => void;
  symbol?: string;
};

const ModalContent = ({ property, onClose, symbol }: Props) => {
  const { t } = useTranslation(["common"]);
  const targetUrl = symbol
    ? "https://cf.ifb.ir/home/trackParticipation"
    : "https://cf.ifb.ir/home/ViewProject";

  // Function to split text based on a newline character
  const renderWithNewline = (text: string) => {
    const parts = text.split("\n");
    return parts.map((part, index) => (
      <React.Fragment key={index}>
        {part}
        {index < parts.length - 1 && <br />}{" "}
        {/* Add line break between parts */}
      </React.Fragment>
    ));
  };

  return (
    <Stack width={"100%"} alignItems={"center"} p={3}>
      <InfoOutlinedIcon
        color="info"
        style={{ marginBottom: 5, width: 64, height: 64 }}
      />
      <Typography gutterBottom variant="headingMedium">
        {t("common:attention")}
      </Typography>

      <Typography variant="bodyMedium" sx={{ textAlign: "center" }}>
        {symbol
          ? renderWithNewline(
              t("common:transaction_farabourse_trace_code_copied", {
                symbol: symbol || "-",
              })
            )
          : renderWithNewline(
              t("common:property_symbol_copied", {
                symbol: property?.symbol || property?.symbol_fa || "-",
              })
            )}
      </Typography>

      <Stack direction="row" alignItems={"center"} mt={2} spacing={2}>
        <a href={targetUrl} target="_blank" rel="noreferrer">
          <Button variant="contained" color="primary">
            {t("common:confirmation")}
          </Button>
        </a>
        <Button type="button" onClick={onClose} variant="outlined">
          {t("common:cancel")}
        </Button>
      </Stack>
    </Stack>
  );
};

export default ModalContent;
